import { Link } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useLang } from "@/context/LanguageContext";

export default function PaymentCancel() {
  const { lang } = useLang();
  const t = (it, en) => (lang === "it" ? it : en);
  return (
    <div className="min-h-screen bg-slate-50">
      <Header />
      <main className="mx-auto max-w-2xl px-6 py-16" data-testid="payment-cancel-page">
        <div className="rounded-2xl border border-slate-200 bg-white p-8 shadow-sm text-center">
          <div className="mx-auto mb-4 grid h-14 w-14 place-items-center rounded-full bg-amber-100 text-amber-700">
            <XCircle className="h-8 w-8" strokeWidth={2} />
          </div>
          <h1 className="font-heading text-2xl font-semibold text-slate-900">
            {t("Pagamento annullato", "Payment cancelled")}
          </h1>
          <p className="mt-2 text-sm text-slate-500">
            {t("Nessun addebito è stato effettuato. Puoi riprovare in qualsiasi momento.", "No charge was made. You can retry any time.")}
          </p>
          <div className="mt-6">
            <Link to="/riclassifica">
              <Button className="rounded-full bg-blue-700 text-white hover:bg-blue-800">
                <ArrowLeft className="mr-2 h-4 w-4" strokeWidth={2} />
                {t("Torna al report", "Back to report")}
              </Button>
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
